import { render, staticRenderFns } from "./CListItemDetailHeaderTitle.vue?vue&type=template&id=6ebf13c4&"
import script from "./CListItemDetailHeaderTitle.vue?vue&type=script&lang=ts&"
export * from "./CListItemDetailHeaderTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports